
export const ACTIVITY_TYPE = {
    notSpecified: 0,
    meeting: 1,
    teamDiscussion: 2,
    individualAssignment: 3
};

export const POINT_TYPE = {
    experience: 1,
    bonus: 2
};

export const CONNECTION_STATUS = {
    sendRequest: 0,
    requestSent: 1,
    requestRecieved: 2,
    connected: 3
};

export const FILE_TYPE = {
    notSpecified: 0,
    attachment: 1,
    thumbnail: 2
};

export const LINK_TYPE = {
    notSpecified: 0,
    imagePath: 1,
    videoPath: 2,
    quickLink: 3,
    referenceMaterial: 4,
    connect: 5,
    own: 6,
    solve: 7,
    communicate: 8,
    onboardingVideo: 9
};


export const ROLE = {
    notSpecified: 0,
    super: 1,
    manager: 2,
    admin: 3,
    learner: 4,
    coach: 5,
    cast: 6,
    guest: 7
};